import React from 'react';
import { LeadText, Title } from '@gje/typography/lib';
import HelpBox from '../../../../components/HelpBox/HelpBox';
import uuid from 'uuid';
import classNames from 'classnames';
import useMobile from '../../../../../hooks/useMobile';
import { HtmlPanel } from '../../../../components/HtmlPanel/HtmlPanel';

interface HeaderProps {
    headerText: string;
    helpText: string;
    leadText: string;
}

export const InformationPanel: React.FunctionComponent<HeaderProps> = ({
    headerText,
    helpText,
    leadText
}) => {
    const isMobileOrSmallScreen = useMobile();

    return (
        <div
            className={classNames(`healthcare-informaton-step-header row`, {
                'mobile-padding': isMobileOrSmallScreen
            })}>
            <div
                className={classNames({ 'col-sm-1-5': !isMobileOrSmallScreen })}
            />
            <div className={`col-sm-${isMobileOrSmallScreen ? '23' : '20'}`}>
                <Title tag="h4">
                    <HtmlPanel>{headerText}</HtmlPanel>
                    <HelpBox
                        helpText={helpText}
                        id={`help-text-${uuid.v4()}`}
                        place="bottom"
                    />
                </Title>
                <LeadText className={'title-without-bold margin-top-13'}>
                    {leadText}
                </LeadText>
            </div>
            <div
                className={classNames({ 'col-sm-1-5': !isMobileOrSmallScreen })}
            />
        </div>
    );
};
